import React from "react";
import { Button, Card, Form, InputGroup } from "react-bootstrap";
import { IonIcon } from "@ionic/react";
import { imageOutline, trashOutline } from "ionicons/icons";
import EditableTitle from "./EditableTitle";

export default function ScriptMainDataPanel({
  handleDimensionChange,
  handleScriptChange,
  handleSubmit,
  onRemoveScriptImage,
  onScriptFileChange,
  previewImage,
  script,
  scriptFileInputRef,
  t,
  userDimensions
}) {
  return (
    <Card className="h-100 shadow-sm">
      <Card.Body className="d-flex flex-column gap-3">
        <EditableTitle
          editLabel={t("editName")}
          name="name"
          value={script.name}
          onChange={handleScriptChange}
          placeholder={t("scriptNamePlaceholder")}
          aria-label={t("name")}
          className="border-0 shadow-none px-0 fs-4 fw-semibold bg-transparent"
          required
        />

        <InputGroup>
          <InputGroup.Text>{t("room")}</InputGroup.Text>
          <Form.Control
            name="room"
            value={script.room}
            onChange={handleScriptChange}
            placeholder={t("room")}
            required
          />
        </InputGroup>

        {["width", "height", "depth"].map((dimension) => (
          <InputGroup key={dimension}>
            <InputGroup.Text>
              {{
                width: t("width"),
                height: t("height"),
                depth: t("depth")
              }[dimension]}
            </InputGroup.Text>
            <Form.Control
              type="number"
              name={dimension}
              value={userDimensions[dimension]}
              onChange={handleDimensionChange}
            />
          </InputGroup>
        ))}

        <div>
          <div className="d-flex align-items-center justify-content-between gap-2 mb-2">
            <Form.Label className="fw-semibold mb-0">
              {t("scriptImage")}
            </Form.Label>
            <div className="d-flex gap-2">
              <Button
                size="sm"
                variant="outline-danger"
                onClick={onRemoveScriptImage}
                disabled={!previewImage}
                title={t("delete")}
                aria-label={t("delete")}
              >
                <IonIcon icon={trashOutline} />
              </Button>
              <Button
                size="sm"
                variant="outline-secondary"
                onClick={() => scriptFileInputRef.current?.click()}
                title={t("changeImage")}
                aria-label={t("changeImage")}
              >
                <IonIcon icon={imageOutline} />
              </Button>
              <input
                type="file"
                accept="image/*"
                ref={scriptFileInputRef}
                onChange={onScriptFileChange}
                className="d-none"
              />
            </div>
          </div>
          <div className="border rounded p-3 text-center">
              {previewImage ? (
                <img
                  src={previewImage}
                  alt={script.name || "Script preview"}
                  style={{
                    width: "100%",
                    height: 260,
                    objectFit: "contain",
                    border: "1px solid #ccc"
                  }}
                />
              ) : (
                <span className="text-muted">{t("imageAfterSaveHint")}</span>
              )}
          </div>
        </div>

        <Button
          size="lg"
          className="w-100 mt-auto"
          variant="primary"
          onClick={handleSubmit}
        >
          {t("saveScript")}
        </Button>
      </Card.Body>
    </Card>
  );
}
